import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import MessageRoom from 'types/message_room'

const resource = 'message_rooms'

export const requests = {
  fetchRooms: async (params?: { worker_name?: string; worker_id?: number }) => {
    return await axiosForGigbaseBiz.get<DataResponse<MessageRoom[]>>(resource, {
      params,
    })
  },
  fetchRoom: async (id: number) => {
    return await axiosForGigbaseBiz.get<DataResponse<MessageRoom>>(
      `${resource}/${id}`,
    )
  },
  createRoom: async (worker_id: number) => {
    return await axiosForGigbaseBiz.post<DataResponse<MessageRoom>>(resource, {
      worker_id,
    })
  },
}
